"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BM_ADDITIONAL_CURRENCIES = exports.Currencies = void 0;
var tslib_1 = require("tslib");
var Currencies;
(function (Currencies) {
    Currencies["AUD"] = "AUD";
    Currencies["BRL"] = "BRL";
    Currencies["CAD"] = "CAD";
    Currencies["CHF"] = "CHF";
    Currencies["CZK"] = "CZK";
    Currencies["DKK"] = "DKK";
    Currencies["EUR"] = "EUR";
    Currencies["GBP"] = "GBP";
    Currencies["HKD"] = "HKD";
    Currencies["HUF"] = "HUF";
    Currencies["ILS"] = "ILS";
    Currencies["JPY"] = "JPY";
    Currencies["MXN"] = "MXN";
    Currencies["MYR"] = "MYR";
    Currencies["NOK"] = "NOK";
    Currencies["NZD"] = "NZD";
    Currencies["PHP"] = "PHP";
    Currencies["PLN"] = "PLN";
    Currencies["RUB"] = "RUB";
    Currencies["SEK"] = "SEK";
    Currencies["SGD"] = "SGD";
    Currencies["THB"] = "THB";
    Currencies["TWD"] = "TWD";
    Currencies["USD"] = "USD";
    Currencies["BIF"] = "BIF";
    Currencies["CVE"] = "CVE";
    Currencies["KMF"] = "KMF";
    Currencies["CDF"] = "CDF";
    Currencies["DJF"] = "DJF";
    Currencies["ERN"] = "ERN";
    Currencies["GNF"] = "GNF";
    Currencies["LSL"] = "LSL";
    Currencies["LYD"] = "LYD";
    Currencies["MWK"] = "MWK";
    Currencies["MRO"] = "MRO";
    Currencies["SLL"] = "SLL";
    Currencies["SZL"] = "SZL";
    Currencies["TJS"] = "TJS";
    Currencies["TOP"] = "TOP";
    Currencies["XPF"] = "XPF";
    Currencies["XOF"] = "XOF";
    Currencies["XAF"] = "XAF";
    Currencies["WST"] = "WST";
    Currencies["VUV"] = "VUV";
    Currencies["UGX"] = "UGX";
    Currencies["TZS"] = "TZS";
    Currencies["STD"] = "STD";
    Currencies["RWF"] = "RWF";
    Currencies["PGK"] = "PGK";
    Currencies["MVR"] = "MVR";
    Currencies["MOP"] = "MOP";
    Currencies["MMK"] = "MMK";
    Currencies["MDL"] = "MDL";
    Currencies["HTG"] = "HTG";
    Currencies["GMD"] = "GMD";
    Currencies["GEL"] = "GEL";
    Currencies["ETB"] = "ETB";
    Currencies["BTN"] = "BTN";
    Currencies["BDT"] = "BDT";
    Currencies["AOA"] = "AOA";
    Currencies["AED"] = "AED";
    Currencies["MGA"] = "MGA";
    Currencies["GHS"] = "GHS";
    Currencies["TMT"] = "TMT";
    Currencies["DZD"] = "DZD";
    Currencies["MAD"] = "MAD";
    Currencies["KWD"] = "KWD";
    Currencies["TND"] = "TND";
    Currencies["AZN"] = "AZN";
    Currencies["BGL"] = "BGL";
    Currencies["BGN"] = "BGN";
    Currencies["UZS"] = "UZS";
    Currencies["KZT"] = "KZT";
    Currencies["KGS"] = "KGS";
    Currencies["RSD"] = "RSD";
    Currencies["MKD"] = "MKD";
    Currencies["TTD"] = "TTD";
    Currencies["PEN"] = "PEN";
    Currencies["SOS"] = "SOS";
    Currencies["IDR"] = "IDR";
    Currencies["DOP"] = "DOP";
    Currencies["ZAR"] = "ZAR";
    Currencies["GTQ"] = "GTQ";
    Currencies["BYN"] = "BYN";
    Currencies["BWP"] = "BWP";
    Currencies["MZN"] = "MZN";
    Currencies["ALL"] = "ALL";
    Currencies["RON"] = "RON";
    Currencies["HNL"] = "HNL";
    Currencies["KES"] = "KES";
    Currencies["ISK"] = "ISK";
    Currencies["HRK"] = "HRK";
    Currencies["BAM"] = "BAM";
    Currencies["JOD"] = "JOD";
    Currencies["JMD"] = "JMD";
    Currencies["PYG"] = "PYG";
    Currencies["AWG"] = "AWG";
    Currencies["ANG"] = "ANG";
    Currencies["NIO"] = "NIO";
    Currencies["BZD"] = "BZD";
    Currencies["VEF"] = "VEF";
    Currencies["PAB"] = "PAB";
    Currencies["YER"] = "YER";
    Currencies["SAR"] = "SAR";
    Currencies["QAR"] = "QAR";
    Currencies["OMR"] = "OMR";
    Currencies["SCR"] = "SCR";
    Currencies["PKR"] = "PKR";
    Currencies["NPR"] = "NPR";
    Currencies["MUR"] = "MUR";
    Currencies["LKR"] = "LKR";
    Currencies["UAH"] = "UAH";
    Currencies["MNT"] = "MNT";
    Currencies["LAK"] = "LAK";
    Currencies["VND"] = "VND";
    Currencies["KRW"] = "KRW";
    Currencies["NGN"] = "NGN";
    Currencies["CRC"] = "CRC";
    Currencies["KHR"] = "KHR";
    Currencies["AFN"] = "AFN";
    Currencies["CNY"] = "CNY";
    Currencies["FKP"] = "FKP";
    Currencies["SHP"] = "SHP";
    Currencies["GIP"] = "GIP";
    Currencies["LBP"] = "LBP";
    Currencies["EGP"] = "EGP";
    Currencies["UYU"] = "UYU";
    Currencies["BOB"] = "BOB";
    Currencies["BMD"] = "BMD";
    Currencies["SBD"] = "SBD";
    Currencies["XCD"] = "XCD";
    Currencies["LRD"] = "LRD";
    Currencies["KYD"] = "KYD";
    Currencies["GYD"] = "GYD";
    Currencies["FJD"] = "FJD";
    Currencies["COP"] = "COP";
    Currencies["CLP"] = "CLP";
    Currencies["BSD"] = "BSD";
    Currencies["BND"] = "BND";
    Currencies["BBD"] = "BBD";
    Currencies["ARS"] = "ARS";
    Currencies["NAD"] = "NAD";
    Currencies["SRD"] = "SRD";
    Currencies["BHD"] = "BHD";
    Currencies["AMD"] = "AMD";
    Currencies["TRY"] = "TRY";
    Currencies["INR"] = "INR";
    Currencies["IQD"] = "IQD";
    Currencies["ZMW"] = "ZMW";
})(Currencies = exports.Currencies || (exports.Currencies = {}));
var CURRENCIES = (_a = {},
    _a[Currencies.BIF] = { symbol: 'FBu' },
    _a[Currencies.CVE] = { symbol: '$' },
    _a[Currencies.KMF] = { symbol: 'CF' },
    _a[Currencies.CDF] = { symbol: 'FC' },
    _a[Currencies.DJF] = { symbol: 'Fdj' },
    _a[Currencies.ERN] = { symbol: 'ናቕፋ' },
    _a[Currencies.GNF] = { symbol: 'FG' },
    _a[Currencies.LSL] = { symbol: 'L' },
    _a[Currencies.LYD] = { symbol: 'ل.د' },
    _a[Currencies.MWK] = { symbol: 'MK' },
    _a[Currencies.MRO] = { symbol: 'UM' },
    _a[Currencies.SLL] = { symbol: 'LE' },
    _a[Currencies.SZL] = { symbol: 'L' },
    _a[Currencies.TJS] = { symbol: 'TJS' },
    _a[Currencies.TOP] = { symbol: 'T$' },
    _a[Currencies.XPF] = { symbol: 'F' },
    _a[Currencies.XOF] = { symbol: 'CFA' },
    _a[Currencies.XAF] = { symbol: 'FCFA' },
    _a[Currencies.WST] = { symbol: 'WS$' },
    _a[Currencies.VUV] = { symbol: 'VT' },
    _a[Currencies.UGX] = { symbol: 'USh' },
    _a[Currencies.TZS] = { symbol: 'TSh' },
    _a[Currencies.STD] = { symbol: 'Db' },
    _a[Currencies.RWF] = { symbol: 'R₣' },
    _a[Currencies.PGK] = { symbol: 'K' },
    _a[Currencies.MVR] = { symbol: 'Rf' },
    _a[Currencies.MOP] = { symbol: 'MOP$' },
    _a[Currencies.MMK] = { symbol: 'K' },
    _a[Currencies.MDL] = { symbol: 'L' },
    _a[Currencies.HTG] = { symbol: 'G' },
    _a[Currencies.GMD] = { symbol: 'D' },
    _a[Currencies.GEL] = { symbol: 'GEL' },
    _a[Currencies.ETB] = { symbol: 'Br' },
    _a[Currencies.BTN] = { symbol: 'Nu.' },
    _a[Currencies.BDT] = { symbol: '৳' },
    _a[Currencies.AOA] = { symbol: 'Kz' },
    _a[Currencies.AED] = { symbol: 'AED' },
    _a[Currencies.MGA] = { symbol: 'Ar' },
    _a[Currencies.GHS] = { symbol: 'GH₵' },
    _a[Currencies.TMT] = { symbol: 'T' },
    _a[Currencies.DZD] = { symbol: 'دج' },
    _a[Currencies.MAD] = { symbol: 'د.م.' },
    _a[Currencies.KWD] = { symbol: 'د.ك' },
    _a[Currencies.TND] = { symbol: 'د.ت' },
    _a[Currencies.AZN] = { symbol: 'ман' },
    _a[Currencies.BGL] = { symbol: 'лв', isDisabled: true },
    _a[Currencies.BGN] = { symbol: 'лв' },
    _a[Currencies.UZS] = { symbol: 'сум' },
    _a[Currencies.KZT] = { symbol: '₸' },
    _a[Currencies.KGS] = { symbol: 'сом' },
    _a[Currencies.RSD] = { symbol: 'РСД' },
    _a[Currencies.MKD] = { symbol: 'ден' },
    _a[Currencies.TTD] = { symbol: 'TT$' },
    _a[Currencies.PEN] = { symbol: 'S/.' },
    _a[Currencies.SOS] = { symbol: 'S' },
    _a[Currencies.IDR] = { symbol: 'Rp' },
    _a[Currencies.DOP] = { symbol: 'RD$' },
    _a[Currencies.ZAR] = { symbol: 'R' },
    _a[Currencies.GTQ] = { symbol: 'Q' },
    _a[Currencies.BYN] = { symbol: 'BYR' },
    _a[Currencies.BWP] = { symbol: 'P' },
    _a[Currencies.MZN] = { symbol: 'MT' },
    _a[Currencies.ALL] = { symbol: 'Lek' },
    _a[Currencies.RON] = { symbol: 'lei' },
    _a[Currencies.HNL] = { symbol: 'L' },
    _a[Currencies.KES] = { symbol: 'Ksh' },
    _a[Currencies.ISK] = { symbol: 'kr' },
    _a[Currencies.HRK] = { symbol: 'kn' },
    _a[Currencies.BAM] = { symbol: 'KM' },
    _a[Currencies.JOD] = { symbol: 'JD' },
    _a[Currencies.JMD] = { symbol: 'J$' },
    _a[Currencies.PYG] = { symbol: 'Gs' },
    _a[Currencies.AWG] = { symbol: 'ƒ' },
    _a[Currencies.ANG] = { symbol: 'ƒ' },
    _a[Currencies.NIO] = { symbol: 'C$' },
    _a[Currencies.BZD] = { symbol: 'BZ$' },
    _a[Currencies.VEF] = { symbol: 'Bs' },
    _a[Currencies.PAB] = { symbol: 'B/.' },
    _a[Currencies.YER] = { symbol: '﷼' },
    _a[Currencies.SAR] = { symbol: '﷼' },
    _a[Currencies.QAR] = { symbol: '﷼' },
    _a[Currencies.OMR] = { symbol: '﷼' },
    _a[Currencies.SCR] = { symbol: '₨' },
    _a[Currencies.PKR] = { symbol: '₨' },
    _a[Currencies.NPR] = { symbol: '₨' },
    _a[Currencies.MUR] = { symbol: '₨' },
    _a[Currencies.LKR] = { symbol: '₨' },
    _a[Currencies.UAH] = { symbol: '₴' },
    _a[Currencies.MNT] = { symbol: '₮' },
    _a[Currencies.LAK] = { symbol: '₭' },
    _a[Currencies.VND] = { symbol: '₫' },
    _a[Currencies.KRW] = { symbol: '₩' },
    _a[Currencies.NGN] = { symbol: '₦' },
    _a[Currencies.CRC] = { symbol: '₡' },
    _a[Currencies.KHR] = { symbol: '៛' },
    _a[Currencies.AFN] = { symbol: '؋' },
    _a[Currencies.CNY] = { symbol: '¥' },
    _a[Currencies.FKP] = { symbol: '£' },
    _a[Currencies.SHP] = { symbol: '£' },
    _a[Currencies.GIP] = { symbol: '£' },
    _a[Currencies.LBP] = { symbol: '.ل.ل' },
    _a[Currencies.EGP] = { symbol: '£' },
    _a[Currencies.UYU] = { symbol: '$U' },
    _a[Currencies.BOB] = { symbol: '$b' },
    _a[Currencies.BMD] = { symbol: 'BD$' },
    _a[Currencies.SBD] = { symbol: '$' },
    _a[Currencies.XCD] = { symbol: '$' },
    _a[Currencies.LRD] = { symbol: '$' },
    _a[Currencies.KYD] = { symbol: '$' },
    _a[Currencies.GYD] = { symbol: '$' },
    _a[Currencies.FJD] = { symbol: '$' },
    _a[Currencies.CLP] = { symbol: '$' },
    _a[Currencies.BSD] = { symbol: '$' },
    _a[Currencies.BND] = { symbol: '$' },
    _a[Currencies.BBD] = { symbol: '$' },
    _a[Currencies.ARS] = { symbol: '$' },
    _a[Currencies.NAD] = { symbol: '$' },
    _a[Currencies.SRD] = { symbol: '$' },
    _a[Currencies.BHD] = { symbol: '.د.ب' },
    _a[Currencies.AMD] = { symbol: 'AMD' },
    _a[Currencies.TRY] = { symbol: '₺' },
    _a[Currencies.INR] = { symbol: '₹' },
    _a[Currencies.IQD] = { symbol: 'ع.د' },
    _a[Currencies.ZMW] = { symbol: 'ZK' },
    _a);
var COMMON_CURRENCY_SETTINGS = {
    offset: 2,
    subscription: { min: 0.01, max: 100000, default: 1 },
    rent: { min: 0.01, max: 100000, default: 1 },
    sale: { min: 0.01, max: 100000, default: 1 },
    pricing_plan: { min: 0.01, max: 100000, default: 1 },
};
exports.BM_ADDITIONAL_CURRENCIES = Object.keys(CURRENCIES).reduce(function (acc, currency) {
    var _a;
    return (tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[currency] = tslib_1.__assign(tslib_1.__assign({}, COMMON_CURRENCY_SETTINGS), CURRENCIES[currency]), _a)));
}, {});
//# sourceMappingURL=bm-additional-currencies.js.map